export default {
  modelName: "system_subclass",
  label: "子領域",
  fields: {
    id: {
      type: "text",
      label: 'ID',
      readonly: true
    },
    sequence: {
      type: "text",
      label: "排序",
      maxlength: 10
    },
    icon: {
      type: "image",
      label: "Icon",
      uploadUrl: "/system_class/icon/",
      maxWidth: "100px"
    },
    locales: {
      type: "locales",
      // label: "多語言內容",
      fields: {
        name: {
          type: "text",
          label: "名稱",
          autofocus: true,
          rules: 'required',
          maxlength: 100,
        }
      }
    },
    updated_at: {
      type: "date",
      label: "更新日期",
      readonly: true
    },
    updated_admin: {
      type: "belongsTo",
      label: "最後更新人",
      textKey: "name",
      readonly: true,
    },
  },
  fieldsRead: [
    "locales.name",
  ],
}